import React, { PureComponent } from "react"
import styled from "styled-components"
import { Steps } from "antd"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { isNil, isEmpty } from "ramda"
import { formValueSelector } from "redux-form"
import { injectIntl, FormattedMessage } from "react-intl"
import { compose } from "recompose"
import Wizard from "../../components/renewal-wizard"
import Box from "../../lib/ui/ui-box"
import Logo from "../../components/logo"
import Text from "../../components/text"
import Footer from "../../components/footer"
import axios from "axios"
import { getUserLanguage } from "../../utils/analytics"

const Step = Steps.Step

const FAQLink = styled.a`
  align-self: flex-end;
  margin-left: auto;
`

const MAP_QUESTIONS_TO_PAGE = {
  1: "What is the estimated property value of your home?",
  2: "What is your property address?",
  3: "What is the name and age of the youngest applicant ?",
  4: "What is your contact information?",
  5: "Have you consulted about getting an Equity Release Mortgage?",
  6: "Thank you"
}

class Container extends PureComponent {
  sendValues = async () => {
    const dataToSend = {
      ...this.props.stepOneData,
      ...this.props.stepTwoData,
      ...this.props.stepThreeData,
      ...this.props.stepFourData,
      ...this.props.stepFiveData
    }
    console.log("lets see the props to send...", this.props)
    console.log("Successful post request!", dataToSend)
    try {
      await axios.post("https://api.canadalistings.net/eq.php", dataToSend)
    } catch (err) {
      console.log(err)
    }
  }
  goTo = page => {
    const { history, intl } = this.props
    history.push(`${intl.formatMessage({ id: "routes.reverse" })}/${page + 1}`)
  }

  componentDidUpdate(prevProps, prevState) {
    const { match: { params } } = this.props
    if (params.page === "6" && prevProps.match.params.page !== params.page) {
      this.sendValues()
    }
  }

  validateStep = (step, currentStep, stepName) => {
    const { stepValidationMap } = this.props
    if (currentStep === step) {
      // return "In Progress"
      return <div>&nbsp;</div>
    } else if (stepValidationMap[stepName] === true) {
      // return "Completed"
      return <div>&nbsp;</div>
    } else {
      // return "Waiting"
      return <div>&nbsp;</div>
    }
  }

  render() {
    const { match, intl } = this.props
    const currentStep = match.params.page && Number(match.params.page) - 1
    const page = Number(match.params.page)

    return (
      <Box flexDirection="column" bg="white" align="center">
        <Box
          mt={[5]}
          w={["80%", "80%", "80%", "1200px"]}
          flexDirection="column"
        >
          <Box flexDirection="row" align="center">
            {/* Logo */}
            <Link to="/">
              <Logo src="/logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
            </Link>
            {/* Phone Number */}
            <Box
              class="nav__phone-number"
              mt={[3]}
              ml={[4]}
              onClick={() =>
                window.analytics.track("click to call", {
                  category: "contact",
                  location: `${MAP_QUESTIONS_TO_PAGE[page]}`,
                  label: `${MAP_QUESTIONS_TO_PAGE[page]}`,
                  language: getUserLanguage()
                })
              }
            >
              {/* Link To Phone Number */}
              <a
                href={`tel:${intl.formatMessage({
                  id: "nav.numberFormatted"
                })}`}
              >
                {/* Phone Number */}
                <Text
                  fontFamily="Libre Baskerville"
                  align="center"
                  fontWeight="700"
                  fontSize={[1]}
                  color="actionPrimary"
                >
                  <FormattedMessage id="nav.number" defaults="613-769-9213" />
                </Text>
              </a>
            </Box>
            {/* Link To FAQ */}
            <FAQLink
              href={`${intl.formatMessage({
                id: "nav.faqLink"
              })}`}
            >
              <Text
                align="center"
                fontSize={[1]}
                fontFamily="Libre Baskerville"
                fontWeight="400"
                color="black"
                ml={[3]}
              >
                <FormattedMessage id="nav.faq" defaults="FAQ" />
              </Text>
            </FAQLink>
          </Box>
          <Box flexDirection="column" mt={[2]}>
            <Box flexDirection="row" w={[1, 1, 1, "654px"]} mt={[5]} mx="auto">
              <Box flex={0}>
                <Steps direction="vertical" current={currentStep}>
                  <Step
                    onClick={() => this.goTo(0)}
                    title={this.validateStep(0, currentStep, "one")}
                    description={<div>&nbsp;</div>}
                  />
                  <Step
                    onClick={
                      this.props.isOneValid === true ? () => this.goTo(1) : null
                    }
                    title={this.validateStep(1, currentStep, "two")}
                    description={<div>&nbsp;</div>}
                  />
                  <Step
                    onClick={
                      this.props.isOneValid === true &&
                      this.props.isTwoValid === true
                        ? () => this.goTo(2)
                        : null
                    }
                    title={this.validateStep(2, currentStep, "three")}
                    description={<div>&nbsp;</div>}
                  />
                  <Step
                    onClick={
                      this.props.isOneValid === true &&
                      this.props.isTwoValid === true &&
                      this.props.isThreeValid === true
                        ? () => this.goTo(3)
                        : null
                    }
                    title={this.validateStep(3, currentStep, "four")}
                    description={<div>&nbsp;</div>}
                  />
                  <Step
                    onClick={
                      this.props.isOneValid === true &&
                      this.props.isTwoValid === true &&
                      this.props.isThreeValid === true &&
                      this.props.isFourValid === true
                        ? () => this.goTo(4)
                        : null
                    }
                    title={this.validateStep(4, currentStep, "five")}
                    description={<div>&nbsp;</div>}
                  />
                  <Step
                    onClick={
                      this.props.isOneValid === true &&
                      this.props.isTwoValid === true &&
                      this.props.isThreeValid === true &&
                      this.props.isFourValid === true &&
                      this.props.isFiveValid === true
                        ? () => this.goTo(5)
                        : null
                    }
                    title={this.validateStep(5, currentStep, "six")}
                    description={<div>&nbsp;</div>}
                  />
                </Steps>
              </Box>
              <Box flex={1}>
                <Wizard {...this.props} />
              </Box>
            </Box>
          </Box>
        </Box>
        <Footer {...this.props} />
      </Box>
    )
  }
}

const mapStateToProps = state => {
  const selector = formValueSelector("renewalMortgageWizard")
  const isValid = value => !isNil(value) && !isEmpty(value)

  // Step 1
  const estimatedAmount = selector(state, "estimatedAmount")
  const homeType = selector(state, "homeType")
  // Step 2
  const postalCode = selector(state, "postalCode")
  const province = selector(state, "province")
  const cityTownVillage = selector(state, "cityTownVillage")

  // Step 3
  const salutation = selector(state, "salutation")
  const ageInYears = selector(state, "ageInYears")
  const firstName = selector(state, "firstName")
  const lastName = selector(state, "lastName")

  // Step 4
  const telephoneNumber = selector(state, "telephoneNumber")
  const emailAddress = selector(state, "emailAddress")

  // Step 5
  const consulted = selector(state, "consulted")
  const consultedType = selector(state, "consultedType")
  const consultedTypeOther = selector(state, "consultedTypeOther")

  // 1 Valid?
  const isOneValid =
    isValid(estimatedAmount) && isValid(homeType) ? true : false

  // 2 Valid?
  const isTwoValid =
    isValid(postalCode) && isValid(province) && isValid(cityTownVillage)
      ? true
      : false

  // 3 Valid?
  const isThreeValid =
    isValid(salutation) &&
    isValid(ageInYears) &&
    isValid(firstName) &&
    isValid(lastName)
      ? true
      : false

  // 4 Valid?
  const isFourValid =
    isValid(telephoneNumber) && isValid(emailAddress) ? true : false

  // 5 Valid?
  const isFiveValid = isValid(consulted)

  return {
    // 1 Validity.
    isOneValid: isOneValid,
    // 2 Validity.
    isTwoValid: isTwoValid,
    // 3 Validity.
    isThreeValid: isThreeValid,
    // 4 Validity.
    isFourValid: isFourValid,
    // 5 Validity.
    isFiveValid: isFiveValid,
    // Used in step one.
    stepOneData: {
      estimatedAmount,
      homeType
    },
    // Used in step two.
    stepTwoData: {
      postalCode,
      province,
      cityTownVillage
    },
    // Used in step three.
    stepThreeData: {
      salutation,
      ageInYears,
      firstName,
      lastName
    },
    // Used in step four.
    stepFourData: {
      telephoneNumber,
      emailAddress
    },
    // Used in step five.
    stepFiveData: {
      hasConsulted: consulted,
      hasConsultedType: consultedType,
      hasConsultedTypeOther: consultedTypeOther
    },
    // Validation Map.
    stepValidationMap: {
      one: isValid(selector(state, "one")),
      two: isValid(selector(state, "two")),
      three: isValid(selector(state, "three")),
      four: isValid(selector(state, "four")),
      five: isValid(selector(state, "five"))
    }
  }
}

export default compose(connect(mapStateToProps, null), injectIntl)(Container)



// WEBPACK FOOTER //
// ./src/containers/renewal/renewal.container.js